import { render, staticRenderFns } from "./MainContentIntro.vue?vue&type=template&id=8671f85c&lang=pug"
import script from "./MainContentIntro.vue?vue&type=script&lang=ts"
export * from "./MainContentIntro.vue?vue&type=script&lang=ts"
import style0 from "./MainContentIntro.vue?vue&type=style&index=0&id=8671f85c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports